<div class="main-box">
    <div class="top-most-div" fxLayout="row" fxLayoutAlign="space-between center">
        <div ngbDropdown>
            <button type="button" class="btn selectpicker" id="dropdownBasic1" ngbDropdownToggle
                style="flex-direction: row;padding:9px">
                <img *ngIf="botSelectedImage" [src]="botSelectedImage" width="40" height="40"
                    style="margin-right:10px;border-radius: 50%;" />
                <div fxLayout="column" style="margin-right: 25px;">
                    <span
                        style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.24px; word-wrap: break-word">Showing
                        posts for</span>
                    <span
                        style="width: 100%; color: #0E0E0E; font-size: 14px; font-family: Montserrat; font-weight: 510; letter-spacing: 0.28px; word-wrap: break-word">{{dropdown_botname}}</span>
                </div>
                <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end"
                    *ngIf="!dropdown_icon">keyboard_arrow_down</mat-icon>
                <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end"
                    *ngIf="dropdown_icon">keyboard_arrow_up</mat-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="overflow: auto;max-height: 40vh;"
                class="custom_scrollbar">
                <button ngbDropdownItem *ngFor="let bots of botListArray; let i=index;" style="font-size: 12px;"
                    class="py-2"
                    (click)="getPostByBotId(bots.bot_id);botSelected = bots.bot_id;dropdown_botname = bots.name;botSelectedImage =  allBotConfigurationDetails[i]?.photo">
                    <img *ngIf="allBotConfigurationDetails[i]?.photo" [src]="allBotConfigurationDetails[i]?.photo"
                        width="40" height="40" style="margin-right:10px; border-radius: 50%" />
                    {{bots.name}}
                </button>
            </div>
        </div>
        <div style="display: flex;gap: 10px;">
            <button class="fillter-button" style="background:#386AF6;" routerLink="create-post/new/new/true">
                <div class="create-post-text-icon">
                    <img src="assets/plus-icon.svg">
                    Schedule Post
                </div>
            </button>
            <button class="fillter-button" style="background:#386AF6;" routerLink="create-post/new/new/false">
                <div class="create-post-text-icon">
                    <img src="assets/plus-icon.svg">
                    Create New Post
                </div>
            </button>
        </div>
    </div>


    <div class="top-buttons">
        <button class="fillter-button" style="width: 99px;" (click)="changePostListType(1)"
            [ngStyle]="{'background':postListType === 'Published' ? '#E3ECFB' : 'white'}">
            <span class="fillter-button-text">Published</span>
        </button>
        <button class="fillter-button" style="width: 99px;" (click)="changePostListType(2)"
            [ngStyle]="{'background':postListType === 'Scheduled' ? '#E3ECFB' : 'white'}">
            <span class="fillter-button-text">Schedule</span>
        </button>

    </div>
    <div style="padding: 16px; position: relative;">
        <div fxLayout="row" style="gap: 10px;align-items: center;">
            <div
                style="width: 22%;padding: 10px; height: 45px; background: white;border-radius: 8px;border: 1px #ECECEC solid; display: flex;align-items: center;">
                <mat-icon [ngStyle]="{'color':'#386AF6'}" matSuffix>search</mat-icon>
                <input style="border: none;outline: none;" matInput placeholder="Search by typing here..."
                    (input)="triggerSearchFunction()" [(ngModel)]="searchValue">
            </div>
            <mat-form-field appearance="standard" class="custom-mat-form-field">
                <button class="btn mx-1 filter-btn col-md-3"
                    style="display:inline-flex;justify-content: center;width: 80%" id="reportrange" type="button"
                    (click)="picker.open()">
                    <div style="display: flex; gap: 10px;" *ngIf="startFilterDate==''">
                        <img src="assets/calender.svg">
                        <span style="color: #386AF6; font-size: 14px; font-family: Montserrat;">From</span>
                    </div>
                    <span *ngIf="startFilterDate!=''">{{startFilterDate | dateTransform : 'std'}}</span>
                </button>
                <input [(ngModel)]="startFilterDate" (dateChange)="onFilterStartDateChange($event)" matInput
                    [matDatepicker]="picker" [max] = "today" hidden>
                <mat-datepicker-toggle matIconSuffix [for]="picker" hidden></mat-datepicker-toggle>
                <mat-datepicker #picker hidden></mat-datepicker>
            </mat-form-field>
            <div style="width: 1%; height: 100%; border: 1px #999999 solid"></div>
            <mat-form-field appearance="standard" class="custom-mat-form-field">
                <button class="btn mx-1 filter-btn col-md-3"
                    style="display:inline-flex;justify-content: center;width: 80%" id="reportrange" type="button"
                    (click)="picker1.open()">
                    <div style="display: flex; gap: 10px;" *ngIf="endFilterDate==''">
                        <img src="assets/calender.svg">
                        <span style="color: #386AF6; font-size: 14px; font-family: Montserrat;">To</span>
                    </div>
                    <span *ngIf="endFilterDate!=''">{{endFilterDate | dateTransform : 'std'}}</span>
                </button>
                <input [(ngModel)]="endFilterDate" (dateChange)="onFilterEndDateChange($event)" matInput
                    [matDatepicker]="picker1" [max] = "today" hidden>
                <mat-datepicker-toggle matIconSuffix [for]="picker1" hidden></mat-datepicker-toggle>
                <mat-datepicker #picker1 hidden></mat-datepicker>
            </mat-form-field>
            <div ngbDropdown>
                <button type="button" class="btn selectpicker" id="dropdownBasic1" ngbDropdownToggle
                    style="flex-direction: row;padding:9px">
                    <div fxLayout="column" style="margin-right: 25px;">
                        <span style="width: 100%; color: #0E0E0E; font-size: 14px; font-family: Montserrat; font-weight: 510; letter-spacing: 0.28px; word-wrap: break-word">{{selectedFilter}}</span>
                    </div>
                    <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end"
                        *ngIf="!dropdown_icon">keyboard_arrow_down</mat-icon>
                    <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end"
                        *ngIf="dropdown_icon">keyboard_arrow_up</mat-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="overflow: auto;max-height: 40vh;"
                    class="custom_scrollbar">
                    <button ngbDropdownItem *ngFor="let type of uniquePostTypes; let i=index;" style="font-size: 12px;"
                        class="py-2" (click)="onFilterSelect(type)">
                        {{type}}
                    </button>
                    <button *ngIf="selectedFilter !== 'Post type'" ngbDropdownItem style="font-size: 12px; font-weight: 700;"
                        class="py-2" (click)="onRemoveFilter()">
                        Remove filter
                    </button>
                </div>
            </div>
            <button mat-button color="primary" (click)="resetFilterVariables()">Reset</button>
            <button style="display: flex; position: absolute; align-items: center; justify-content: center; gap: 10px; border-radius: 99px; padding: 14px 24px; border: 1px solid #386AF6; background-color: white; right: 16px;" (click)="downloadCSV()">
                <p style="font-size: 13px; color: #386AF6; margin: 0;">Download</p>
                <img src="assets/csv-icon.svg" alt="csv-icon" />
            </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 10px;">
            <div fxFlex="35%">
                <span class="table-header-text">Title</span>
            </div>
            <div fxFlex="20%" class="text-center">
                <span class="table-header-text" *ngIf="postListType === 'Published'">Date Published</span>
                <span class="table-header-text" *ngIf="postListType === 'Scheduled'">Schedule Date</span>
                <img [src]="sortIconStartTimeSrc" class="arrow-icon" (click)="sortAccToStartTime()">

            </div>
            <div fxFlex="20%" class="text-center" *ngIf="postListType === 'Published'">
                <span class="table-header-text">Reactions</span>
                <img [src]="sortIconReactionSrc" class="arrow-icon" (click)="sortAccToReatctions()">
            </div>
            <div fxFlex="20%" class="text-center" *ngIf="postListType === 'Published'">
                <span class="table-header-text">Posts link</span>
            </div>
            <div fxFlex="25%" class="text-center">
                <!-- <span class="table-header-text"> Entries received </span> -->
            </div>
        </div>
        <div *ngFor="let post of allBotPosts" class="table-item">
            <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                <div fxFlex="35%" class="text-center table-text-item" style="padding-left: 5px;">
                    <div
                        style="padding: 15px; width: 100%; height: 100%; padding-left: 16px; padding-right: 16px; background: white; border-radius: 8px; justify-content: space-between; align-items: center; gap: 6px; display: inline-flex">
                        <img *ngIf="post.type =='question' || post.type =='poll'" src="assets/poll.svg">
                        <img *ngIf="post.type !='question' && post.type !='poll'" src="assets/image-icon.svg">
                        <div *ngIf="post?.content && post?.content.length < 70" [innerHTML]="post?.content"
                            style="word-break: break-all;"></div>
                        <div *ngIf="post?.content && post?.content.length >= 70"
                            [innerHTML]="post?.content.substring(0,70)+'...'" style="word-break: break-all;"></div>
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="duplicatePost(post.post_id)">
                                <span>Duplicate</span>
                            </button>
                            <button mat-menu-item (click)="deletePost(post.post_id)">
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
                <div fxFlex="20%" class="text-center table-text-item" *ngIf="postListType === 'Published'">
                    {{post?.created_at | dateTransform: 'std' }}
                </div>
                <div fxFlex="20%" class="text-center table-text-item" *ngIf="postListType === 'Scheduled'">
                    {{post?.scheduled_time | dateTransform: 'std' }}
                </div>
                <div fxFlex="20%" class="text-center table-text-item" *ngIf="postListType === 'Published'">
                    {{post.totalReaction}}
                </div>
                <div *ngIf="postListType === 'Published'" fxFlex="30%" class="text-center table-text-item">
                    <button tooltip="Copied to clipboard"  (mouseleave)="toolTip.hide()" triggers="" #toolTip="bs-tooltip"   placement="bottom" type="button" [matRippleCentered]="true" matRipple   class="copypost-btn" ngxClipboard (click)="toolTip.show()" [cbContent]="getPostLink(post.post_id)"> Copy Post Link <mat-icon style="font-size: 13px;">
                        content_copy
                    </mat-icon></button>
                </div>

                <div fxFlex="25%" class="text-center" style="display: flex;justify-content: flex-end;">
                    <img src="assets/angle.svg" style="cursor: pointer;"
                        routerLink="post-detail/{{botSelected}}/{{post.post_id}}/{{postListType}}">
                </div>
            </div>
        </div>
        <div *ngIf="allBotPosts.length === 0" style="display: flex; align-items: center; justify-content: center;"><p>No matching posts found</p></div>
        <div class="pagination" *ngIf="totalItems > limit">
            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">Previous</button>
            <button (click)="goToPage(1)" [class.active]="currentPage === 1">1</button>
            <span *ngIf="currentPage > 2">...</span>
            <button 
              *ngFor="let page of visiblePages.slice(1, visiblePages.length - 1)" 
              (click)="goToPage(page)" 
              [class.active]="currentPage === page">
              {{ page }}
            </button>
            <button *ngIf="currentPage <= totalPages" (click)="goToPage(totalPages)" [class.active]="currentPage === totalPages">
              {{ totalPages }}
            </button>
            <span *ngIf="currentPage < totalPages">...</span>
            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Next</button>
        </div>
    </div>

</div>